<template>
  <Breadcrumbs
      title="Stock Allocation"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Stock Allocation', path: '/stock-allocation' },
      { label: 'Edit Stock Allocation', path: '/edit-stock-allocation' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editStockAllocationForm/>
    </div>
  </div>
</template>


<script>
import editStockAllocationForm from '@/pages/stock/stock_allocation/editeStockAllocationForm.vue'

export default {
  components: {
    editStockAllocationForm
  }
}
</script>